<template>
  <v-app>
    <AppHeader v-if="$route.name != 'Login' && $route.name != 'Login Verify'" />
    <router-view />
  </v-app>
</template>

<script>
// import HelloWorld from './components/HelloWorld';
import axios from "axios";
import store from "./store";
import "./assets/styles/style.css";
import "./assets/styles/fonts.css";
import AppHeader from "./components/Common/appHeader";
export default {
  components: {
    AppHeader,
  },
  name: "App",
  data: () => ({
    //
  }),
  beforeMount() {
    if (typeof localStorage.getItem("token") == "string") {
      axios({
        method: "GET",
        url: "/user/profile",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            store.commit("userData", response.data.data);
            this.$store.commit("userType", response.data.data.type);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  },
};
</script>
